/*
 * Totkind — lightbox anh PDP (08/10). Hoc theo lb-lightbox cua litborne.co (chi tham khao, viet lai cho Totkind).
 * - Bam anh/nut zoom trong media-gallery -> mo toan man hinh tai dung anh do.
 * - CHI chay khi khach CHUA ca nhan hoa (user 08/10). Da ca nhan hoa: tk-custom.js chan click o window capture va mo hop preview (rule 07/10).
 * - Zoom: click (desktop) / cham dup (mobile) = 3x tai diem bam; lan chuot; keo de xem; chum 2 ngon. Vuot / phim mui ten doi anh, Esc dong.
 * Du lieu anh: <script id="tk-lb-du-lieu"> (snippets/tk-lightbox.liquid). Khong dung escape "\" trong chuoi (Shopify minify nuot).
 */
(function () {
  if (window.__tkLb) return;
  window.__tkLb = 1;
  var nguon = document.getElementById('tk-lb-du-lieu');
  if (!nguon) return;
  var D; try { D = JSON.parse(nguon.textContent); } catch (e) { return; }
  if (!D.anh || !D.anh.length) return;

  var lb, chinh, san, lui, toi, hangNho, khung = [], idx = 0, daTai = false;

  function tao() {
    lb = document.createElement('div');
    lb.className = 'tk-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', D.ten);
    lb.innerHTML = '<div class="tk-lb__dau"><p class="tk-lb__ten"></p><button type="button" class="tk-lb__dong" aria-label="Close" title="Close (Esc)"></button></div>' +
      '<div class="tk-lb__san"><button type="button" class="tk-lb__mui tk-lb__mui--lui" aria-label="Previous image">‹</button>' +
      '<img class="tk-lb__chinh" alt="" draggable="false">' +
      '<button type="button" class="tk-lb__mui tk-lb__mui--toi" aria-label="Next image">›</button></div>' +
      '<div class="tk-lb__nho" role="tablist" aria-label="Images"></div>';
    document.body.appendChild(lb);
    lb.querySelector('.tk-lb__ten').textContent = D.ten;
    chinh = lb.querySelector('.tk-lb__chinh'); san = lb.querySelector('.tk-lb__san');
    lui = lb.querySelector('.tk-lb__mui--lui'); toi = lb.querySelector('.tk-lb__mui--toi'); hangNho = lb.querySelector('.tk-lb__nho');
    lb.querySelector('.tk-lb__dong').addEventListener('click', dong);
    lui.addEventListener('click', function () { den(idx - 1); });
    toi.addEventListener('click', function () { den(idx + 1); });
    ganZoom();
  }

  function dungKhung() {
    if (khung.length) return;
    khung = D.anh.map(function (a, i) { return { to: a.to, nho: a.nho, alt: a.alt, media: i }; });
    hangNho.innerHTML = '';
    khung.forEach(function (k, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tk-lb__nho-o'; b.setAttribute('aria-label', 'Image ' + (i + 1));
      var im = document.createElement('img'); im.src = k.nho; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im); b.addEventListener('click', function () { den(i); });
      hangNho.appendChild(b);
    });
    var nhieu = khung.length > 1;
    lui.hidden = toi.hidden = hangNho.hidden = !nhieu;
  }
  function taiTruoc() {
    if (daTai) return; daTai = true;
    D.anh.forEach(function (a) { var im = new Image(); im.src = a.to; });
  }

  function mo(viTri) {
    if (!lb) tao();
    dungKhung(); taiTruoc();
    var i = 0;
    for (var j = 0; j < khung.length; j++) if (khung[j].media === viTri) { i = j; break; }
    lb.classList.add('mo');
    document.documentElement.style.overflow = 'hidden';
    den(i, true);
    lb.querySelector('.tk-lb__dong').focus({ preventScroll: true });
  }
  function dong() {
    if (!lb) return;
    datLai();
    lb.classList.remove('mo');
    document.documentElement.style.overflow = '';
  }
  function den(i, ngay) {
    var n = khung.length;
    if (i < 0) i = n - 1;
    if (i >= n) i = 0;
    idx = i; datLai();
    var k = khung[i];
    chinh.alt = k.alt || D.ten;
    var doi = function () {
      chinh.src = k.to;
      if (chinh.complete && chinh.naturalWidth > 0) chinh.classList.remove('dang-tai');
      else chinh.addEventListener('load', function xong() { chinh.classList.remove('dang-tai'); chinh.removeEventListener('load', xong); });
    };
    if (ngay) doi(); else { chinh.classList.add('dang-tai'); requestAnimationFrame(function () { setTimeout(doi, 80); }); }
    [].forEach.call(hangNho.children, function (b, j) { b.classList.toggle('dang', j === i); b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    var b = hangNho.children[i];
    if (b && b.scrollIntoView && !hangNho.hidden) b.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  /* ── zoom / keo / chum / vuot (theo logic litborne.co) ── */
  var ty = 1, dx = 0, dy = 0, TOI_DA = 6, BUOC = 0.5, MUC_CLICK = 3;
  function ve() {
    chinh.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + ty + ')';
    var z = ty > 1.01; chinh.classList.toggle('zoom', z); san.classList.toggle('zoom', z);
  }
  function datLai() { if (!chinh) return; ty = 1; dx = 0; dy = 0; chinh.style.transform = ''; chinh.classList.remove('zoom'); san.classList.remove('zoom'); }
  function datTy(moi, cx, cy) {
    moi = Math.max(1, Math.min(TOI_DA, moi));
    if (moi === ty) return;
    if (typeof cx === 'number') {
      var r = chinh.getBoundingClientRect(), ix = cx - (r.left + r.width / 2), iy = cy - (r.top + r.height / 2), k = moi / ty;
      dx = (dx - ix) * k + ix; dy = (dy - iy) * k + iy;
    }
    ty = moi; if (ty <= 1.01) { dx = 0; dy = 0; }
    ve();
  }
  function ganZoom() {
    san.addEventListener('wheel', function (e) {
      e.preventDefault();
      if (ty > 1.01) {
        var r = chinh.getBoundingClientRect(), s = san.getBoundingClientRect();
        var my = Math.max(0, (r.height - s.height) / 2), mx = Math.max(0, (r.width - s.width) / 2);
        dy = Math.max(-my, Math.min(my, dy - e.deltaY)); dx = Math.max(-mx, Math.min(mx, dx - e.deltaX));
        ve();
      } else datTy(ty + (e.deltaY < 0 ? BUOC : -BUOC), e.clientX, e.clientY);
    }, { passive: false });
    var xuong = null, chamCuoi = 0;
    chinh.addEventListener('mousedown', function (e) { xuong = { x: e.clientX, y: e.clientY }; });
    lb.addEventListener('touchend', function () { chamCuoi = Date.now(); }, { passive: true });
    chinh.addEventListener('click', function (e) {
      if (Date.now() - chamCuoi < 600) return;   /* click gia sau khi cham */
      if (xuong) { var keo = Math.hypot(e.clientX - xuong.x, e.clientY - xuong.y) > 5; xuong = null; if (keo) return; }
      if (ty <= 1.01) datTy(MUC_CLICK, e.clientX, e.clientY); else datLai();
    });
    var keoTu = null;
    san.addEventListener('mousedown', function (e) {
      if (ty <= 1.01) return;
      keoTu = { x: e.clientX - dx, y: e.clientY - dy }; san.classList.add('keo'); e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) { if (!keoTu) return; dx = e.clientX - keoTu.x; dy = e.clientY - keoTu.y; ve(); });
    window.addEventListener('mouseup', function () { if (!keoTu) return; keoTu = null; san.classList.remove('keo'); });
    /* cham: 1 ngon keo khi dang zoom, 2 ngon chum; cham dup = zoom; vuot ngang = doi anh (khi khong zoom) */
    var chamTu = null, chumD = 0, chumTy = 1, vx = 0, vy = 0, vt = 0, tapCuoi = 0, tapX = 0, tapY = 0;
    var kc = function (a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); };
    san.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { chumD = kc(e.touches[0], e.touches[1]); chumTy = ty; }
      else if (e.touches.length === 1) {
        vx = e.touches[0].clientX; vy = e.touches[0].clientY; vt = Date.now();
        if (ty > 1.01) chamTu = { x: vx - dx, y: vy - dy };
      }
    }, { passive: true });
    san.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && chumD > 0) {
        e.preventDefault();
        datTy(chumTy * (kc(e.touches[0], e.touches[1]) / chumD), (e.touches[0].clientX + e.touches[1].clientX) / 2, (e.touches[0].clientY + e.touches[1].clientY) / 2);
      } else if (e.touches.length === 1 && chamTu && ty > 1.01) {
        e.preventDefault(); dx = e.touches[0].clientX - chamTu.x; dy = e.touches[0].clientY - chamTu.y; ve();
      }
    }, { passive: false });
    san.addEventListener('touchend', function (e) {
      chamTu = null; chumD = 0;
      if (e.changedTouches.length !== 1 || e.touches.length) return;
      var t = e.changedTouches[0], mx = t.clientX - vx, my = t.clientY - vy, xa = Math.hypot(mx, my), lau = Date.now() - vt;
      if (xa < 10 && lau < 300) {
        var bay = Date.now();
        if (bay - tapCuoi < 300 && Math.hypot(t.clientX - tapX, t.clientY - tapY) < 40) {
          if (ty > 1.01) datLai(); else datTy(MUC_CLICK, t.clientX, t.clientY);
          tapCuoi = 0; return;
        }
        tapCuoi = bay; tapX = t.clientX; tapY = t.clientY; return;
      }
      tapCuoi = 0;
      if (ty > 1.01) return;
      if (Math.abs(mx) > 50 && Math.abs(mx) > Math.abs(my)) den(idx + (mx < 0 ? 1 : -1));
    }, { passive: true });
  }

  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('mo')) return;
    if (e.key === 'Escape') dong();
    else if (e.key === 'ArrowLeft') den(idx - 1);
    else if (e.key === 'ArrowRight') den(idx + 1);
  });

  /* vi tri media cua 1 o trong gallery: doc tu nut zoom ("/zoom/N") hoac thu tu o */
  function viTriMedia(o) {
    if (!o) return 0;
    var z = o.querySelector('.product-media-container__zoom-button');
    var m = z && /zoom\/(\d+)/.exec(z.getAttribute('on:click') || '');
    if (m) return +m[1];
    var tat = [].slice.call(o.parentElement ? o.parentElement.children : []).filter(function (x) { return x.classList && (x.classList.contains('product-media-container') || x.tagName === 'SLIDESHOW-SLIDE'); });
    var i = tat.indexOf(o); return i < 0 ? 0 : Math.min(i, D.anh.length - 1);
  }
  /* bat click o WINDOW capture (Horizon nghe document capture va dang ky truoc -> chan o document la muon, mobile mo ca zoom-dialog cua theme).
     Khach DA ca nhan hoa / vua keo anh: tk-custom.js xu ly va gan e.__tkcXuLy -> doi het listener cung tang roi moi quyet dinh. */
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var g = t.closest('media-gallery'); if (!g) return;
    var nutZoom = t.closest('.product-media-container__zoom-button');
    if (!nutZoom && t.closest('button, a, input, select, textarea, label, [role="button"]')) return;
    var o = t.closest('.product-media-container, slideshow-slide'); if (!o) return;
    if (e.__tkcXuLy) return;
    e.preventDefault(); e.stopPropagation();
    var vt = viTriMedia(o);
    setTimeout(function () { if (!e.__tkcXuLy) mo(vt); }, 0);
  }, true);
})();
